/**
 * @file Builds one export column per tier of a single project.
 */
import getInvestmentAmountForProjectTier from "./getInvestmentAmountForProjectTier";
import type { Column, Project, Investment, GetTierTitle } from "../types";

/**
 * Builds one export column per tier of the given project, each column showing the invested amount for that tier.
 */
const getInvestmentClassColumns = (project: Project, getTierName: GetTierTitle): Column[] => {
  const { tiers: projectTiers } = project;

  const columns = projectTiers.map((tier) => {
    const { name: tierId } = tier;

    const title = getTierName(tier);

    /**
     * Returns the invested amount for this tier's column.
     */
    const value = (investment: Investment): string => {
      const amount = getInvestmentAmountForProjectTier(tierId, investment);

      return amount;
    };

    return {
      value,
      title,
    };
  });

  return columns;
};

export default getInvestmentClassColumns;
